export default __webpack_public_path__ + "static/media/a-and-d-logo-1200px.3cfc4f79.png";